var _toConsumableArray = require("/home/ubuntu/code/scenario_simulation/source/server_app_v001/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _asyncToGenerator = require("/home/ubuntu/code/scenario_simulation/source/server_app_v001/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/home/ubuntu/code/scenario_simulation/source/server_app_v001/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/ubuntu/code/scenario_simulation/source/server_app_v001/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var JSONDigger = /*#__PURE__*/function () {
  "use strict";

  function JSONDigger(datasource, idProp, childrenProp) {
    _classCallCheck(this, JSONDigger);
    this.ds = datasource;
    this.id = idProp;
    this.children = childrenProp;
    this.count = 0;
  }
  _createClass(JSONDigger, [{
    key: "countNodes",
    value: function countNodes(obj) {
      var _this = this;
      this.count++;
      if (!obj || !Object.keys(obj).length) {
        return false;
      } else {
        if (obj[this.children]) {
          obj[this.children].forEach(function (child) {
            _this.countNodes(child);
          });
        }
      }
    }
  }, {
    key: "findNodeById",
    value: function findNodeById(id) {
      var _this2 = this;
      var _this = this;
      // this.count = 0;
      this.countNodes(this.ds);
      return new Promise(function (resolve, reject) {
        if (!id) {
          return reject(new Error('Parameter id is invalid.'));
        }
        function findNodeById(obj, id, callback) {
          if (!_this.count) {
            return;
          }
          if (obj[_this.id] === id) {
            _this.count = 0;
            callback(null, obj);
          } else {
            if (_this.count === 1) {
              _this.count = 0;
              callback('The node doesn\'t exist.', null);
            }
            _this.count--;
            if (obj[_this.children]) {
              obj[_this.children].forEach(function (node) {
                findNodeById(node, id, callback);
              });
            }
          }
        }
        findNodeById(_this2.ds, id, function (msg, node) {
          if (msg) {
            reject(new Error(msg));
          } else {
            resolve(node);
          }
        });
      });
    }
  }, {
    key: "matchConditions",
    value: function matchConditions(obj, conditions) {
      var flag = true;
      Object.keys(conditions).some(function (item) {
        if (typeof conditions[item] === 'string' || typeof conditions[item] === 'number' || typeof conditions[item] === 'boolean') {
          if (obj[item] !== conditions[item]) {
            flag = false;
            return true;
          }
        } else if (conditions[item] instanceof RegExp) {
          if (!conditions[item].test(obj[item])) {
            flag = false;
            return true;
          }
        } else if (typeof conditions[item] === 'object') {
          Object.keys(conditions[item]).some(function (subitem) {
            switch (subitem) {
              case '>':
                {
                  if (!(obj[item] > conditions[item][subitem])) {
                    flag = false;
                    return true;
                  }
                  break;
                }
              case '<':
                {
                  if (!(obj[item] < conditions[item][subitem])) {
                    flag = false;
                    return true;
                  }
                  break;
                }
              case '>=':
                {
                  if (!(obj[item] >= conditions[item][subitem])) {
                    flag = false;
                    return true;
                  }
                  break;
                }
              case '<=':
                {
                  if (!(obj[item] <= conditions[item][subitem])) {
                    flag = false;
                    return true;
                  }
                  break;
                }
              case '!==':
                {
                  if (!(obj[item] !== conditions[item][subitem])) {
                    flag = false;
                    return true;
                  }
                  break;
                }
            }
          });
          if (!flag) {
            return false;
          }
        }
      });
      return flag;
    }
  }, {
    key: "findChildren",
    value: function () {
      var _findChildren = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var _this, parent;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = this;
              if (id) {
                _context.next = 3;
                break;
              }
              throw new Error('Parameter id is invalid.');
            case 3:
              _context.prev = 3;
              _context.next = 6;
              return this.findParent(id);
            case 6:
              parent = _context.sent;
              return _context.abrupt("return", parent[this.children]);
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              throw new Error('The child nodes don\'t exist.');
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 10]]);
      }));
      function findChildren(_x) {
        return _findChildren.apply(this, arguments);
      }
      return findChildren;
    }()
  }, {
    key: "findNodes",
    value: function findNodes(conditions) {
      var _this3 = this;
      var _this = this;
      this.countNodes(this.ds);
      return new Promise(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
          var nodes, findNodes;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                findNodes = function _findNodes(obj, conditions, callback) {
                  if (!_this.count) {
                    return;
                  }
                  if (_this.matchConditions(obj, conditions)) {
                    nodes.push(obj);
                    if (_this.count === 1) {
                      _this.count = 0;
                      callback(!nodes.length ? 'The nodes don\'t exist.' : null, nodes.slice(0));
                    }
                  } else {
                    if (_this.count === 1) {
                      _this.count = 0;
                      callback(!nodes.length ? 'The nodes don\'t exist.' : null, nodes.slice(0));
                    }
                  }
                  _this.count--;
                  if (obj[_this.children]) {
                    obj[_this.children].forEach(function (child) {
                      findNodes(child, conditions, callback);
                    });
                  }
                };
                if (!(!conditions || !Object.keys(conditions).length)) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return", reject(new Error('Parameter conditions are invalid.')));
              case 3:
                nodes = [];
                findNodes(_this3.ds, conditions, function (msg, nodes) {
                  if (msg) {
                    reject(new Error(msg));
                  } else {
                    resolve(nodes);
                  }
                });
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "findParent",
    value: function findParent(id) {
      var _this4 = this;
      var _this = this;
      this.countNodes(this.ds);
      return new Promise(function (resolve, reject) {
        if (!id) {
          return reject(new Error('Parameter id is invalid.'));
        }
        function findParent(obj, id, callback) {
          if (_this.count === 1) {
            _this.count = 0;
            callback('The parent node doesn\'t exist.', null);
          } else {
            _this.count--;
            if (typeof obj[_this.children] !== 'undefined') {
              obj[_this.children].forEach(function (child) {
                if (child[_this.id] === id) {
                  _this.count = 0;
                  callback(null, obj);
                }
              });
              obj[_this.children].forEach(function (child) {
                findParent(child, id, callback);
              });
            }
          }
        }
        findParent(_this4.ds, id, function (msg, parent) {
          if (msg) {
            reject(new Error(msg));
          } else {
            resolve(parent);
          }
        });
      });
    }
  }, {
    key: "findSiblings",
    value: function () {
      var _findSiblings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(id) {
        var _this, parent;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = this;
              if (id) {
                _context3.next = 3;
                break;
              }
              throw new Error('Parameter id is invalid.');
            case 3:
              _context3.prev = 3;
              _context3.next = 6;
              return this.findParent(id);
            case 6:
              parent = _context3.sent;
              return _context3.abrupt("return", parent[this.children].filter(function (child) {
                return child[_this.id] !== id;
              }));
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](3);
              throw new Error('The sibling nodes don\'t exist.');
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[3, 10]]);
      }));
      function findSiblings(_x4) {
        return _findSiblings.apply(this, arguments);
      }
      return findSiblings;
    }()
  }, {
    key: "findAncestors",
    value: function findAncestors(id) {
      var _this = this;
      return new Promise(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(resolve, reject) {
          var nodes, findAncestors, _findAncestors, ancestors;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _findAncestors = function _findAncestors3() {
                  _findAncestors = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(id) {
                    var parent;
                    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.prev = 0;
                          if (!(id === _this.ds[_this.id])) {
                            _context4.next = 7;
                            break;
                          }
                          if (nodes.length) {
                            _context4.next = 4;
                            break;
                          }
                          throw new Error('The ancestor nodes don\'t exist.');
                        case 4:
                          return _context4.abrupt("return", nodes.slice(0));
                        case 7:
                          _context4.next = 9;
                          return _this.findParent(id);
                        case 9:
                          parent = _context4.sent;
                          nodes.push(parent);
                          return _context4.abrupt("return", findAncestors(parent[_this.id]));
                        case 12:
                          _context4.next = 17;
                          break;
                        case 14:
                          _context4.prev = 14;
                          _context4.t0 = _context4["catch"](0);
                          throw new Error('The ancestor nodes don\'t exist.');
                        case 17:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4, null, [[0, 14]]);
                  }));
                  return _findAncestors.apply(this, arguments);
                };
                findAncestors = function _findAncestors2(_x7) {
                  return _findAncestors.apply(this, arguments);
                };
                if (id) {
                  _context5.next = 4;
                  break;
                }
                return _context5.abrupt("return", reject(new Error('Parameter id is invalid.')));
              case 4:
                nodes = [];
                _context5.prev = 5;
                _context5.next = 8;
                return findAncestors(id);
              case 8:
                ancestors = _context5.sent;
                resolve(ancestors);
                _context5.next = 15;
                break;
              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](5);
                reject(_context5.t0);
              case 15:
              case "end":
                return _context5.stop();
            }
          }, _callee5, null, [[5, 12]]);
        }));
        return function (_x5, _x6) {
          return _ref2.apply(this, arguments);
        };
      }());
    } // validate the input parameters id and data(could be oject or array)
  }, {
    key: "validateParams",
    value: function validateParams(id, data) {
      if (!id) {
        throw new Error('Parameter id is invalid.');
      }
      if (!data || data.constructor !== Object && data.constructor !== Array || data.constructor === Object && !Object.keys(data).length || data.constructor === Array && !data.length || data.constructor === Array && data.length && !data.every(function (item) {
        return item && item.constructor === Object && Object.keys(item).length;
      })) {
        throw new Error('Parameter data is invalid.');
      }
    }
  }, {
    key: "addChildren",
    value: function () {
      var _addChildren = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(id, data) {
        var parent, _parent$this$children;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.validateParams(id, data);
              _context6.prev = 1;
              _context6.next = 4;
              return this.findNodeById(id);
            case 4:
              parent = _context6.sent;
              if (data.constructor === Object) {
                if (parent[this.children]) {
                  parent[this.children].push(data);
                } else {
                  parent[this.children] = [data];
                }
              } else {
                if (parent[this.children]) {
                  (_parent$this$children = parent[this.children]).push.apply(_parent$this$children, _toConsumableArray(data));
                } else {
                  parent[this.children] = data;
                }
              }
              _context6.next = 11;
              break;
            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](1);
              throw new Error('Failed to add child nodes.');
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 8]]);
      }));
      function addChildren(_x8, _x9) {
        return _addChildren.apply(this, arguments);
      }
      return addChildren;
    }()
  }, {
    key: "addSiblings",
    value: function () {
      var _addSiblings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(id, data) {
        var parent, _parent$this$children2;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.validateParams(id, data);
              _context7.prev = 1;
              _context7.next = 4;
              return this.findParent(id);
            case 4:
              parent = _context7.sent;
              if (data.constructor === Object) {
                parent[this.children].push(data);
              } else {
                (_parent$this$children2 = parent[this.children]).push.apply(_parent$this$children2, _toConsumableArray(data));
              }
              _context7.next = 11;
              break;
            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](1);
              throw new Error('Failed to add sibling nodes.');
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[1, 8]]);
      }));
      function addSiblings(_x10, _x11) {
        return _addSiblings.apply(this, arguments);
      }
      return addSiblings;
    }()
  }, {
    key: "addRoot",
    value: function addRoot(data) {
      var _this5 = this;
      var _this = this;
      if (!data || data.constructor !== Object || data.constructor === Object && !Object.keys(data).length) {
        throw new Error('Parameter data is invalid.');
      }
      try {
        this.ds[this.children] = [Object.assign({}, this.ds)];
        delete data[this.children];
        Object.keys(this.ds).filter(function (prop) {
          return prop !== _this5.children;
        }).forEach(function (prop) {
          if (!data[prop]) {
            delete _this5.ds[prop];
          }
        });
        Object.assign(this.ds, data);
      } catch (err) {
        throw new Error('Failed to add root node.');
      }
    }
  }, {
    key: "updateNode",
    value: function () {
      var _updateNode = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(data) {
        var node;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(!data || data.constructor !== Object || data.constructor === Object && !Object.keys(data).length || data.constructor === Object && Object.keys(data).length && !data[this.id])) {
                _context8.next = 2;
                break;
              }
              throw new Error('Parameter data is invalid.');
            case 2:
              _context8.prev = 2;
              _context8.next = 5;
              return this.findNodeById(data[this.id]);
            case 5:
              node = _context8.sent;
              Object.assign(node, data);
              _context8.next = 12;
              break;
            case 9:
              _context8.prev = 9;
              _context8.t0 = _context8["catch"](2);
              throw new Error('Failed to update node.');
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[2, 9]]);
      }));
      function updateNode(_x12) {
        return _updateNode.apply(this, arguments);
      }
      return updateNode;
    }()
  }, {
    key: "updateNodes",
    value: function () {
      var _updateNodes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(ids, data) {
        var _this, _iterator, _step, id;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this = this;
              if (!(!ids || ids.constructor === Array && !ids.length || !data)) {
                _context9.next = 3;
                break;
              }
              throw new Error('Input parameter is invalid.');
            case 3:
              _context9.prev = 3;
              _iterator = _createForOfIteratorHelper(ids);
              _context9.prev = 5;
              _iterator.s();
            case 7:
              if ((_step = _iterator.n()).done) {
                _context9.next = 14;
                break;
              }
              id = _step.value;
              data[_this.id] = id;
              _context9.next = 12;
              return this.updateNode(data);
            case 12:
              _context9.next = 7;
              break;
            case 14:
              _context9.next = 19;
              break;
            case 16:
              _context9.prev = 16;
              _context9.t0 = _context9["catch"](5);
              _iterator.e(_context9.t0);
            case 19:
              _context9.prev = 19;
              _iterator.f();
              return _context9.finish(19);
            case 22:
              _context9.next = 27;
              break;
            case 24:
              _context9.prev = 24;
              _context9.t1 = _context9["catch"](3);
              throw _context9.t1;
            case 27:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[3, 24], [5, 16, 19, 22]]);
      }));
      function updateNodes(_x13, _x14) {
        return _updateNodes.apply(this, arguments);
      }
      return updateNodes;
    }() // remove single node based on id
  }, {
    key: "removeNode",
    value: function () {
      var _removeNode = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(id) {
        var _this, parent, index, removed;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this = this;
              if (!(id === this.ds[this.id])) {
                _context10.next = 3;
                break;
              }
              throw new Error('Input parameter is invalid.');
            case 3:
              _context10.prev = 3;
              _context10.next = 6;
              return this.findParent(id);
            case 6:
              parent = _context10.sent;
              index = parent[this.children].map(function (node) {
                return node[_this.id];
              }).indexOf(id);
              removed = parent[this.children].splice(index, 1);
              this.count = 0;
              return _context10.abrupt("return", parent);
            case 13:
              _context10.prev = 13;
              _context10.t0 = _context10["catch"](3);
              throw new Error('Failed to remove node.');
            case 16:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[3, 13]]);
      }));
      function removeNode(_x15) {
        return _removeNode.apply(this, arguments);
      }
      return removeNode;
    }() // param could be single id, id array or conditions object
  }, {
    key: "removeNodes",
    value: function () {
      var _removeNodes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(param) {
        var _this, _iterator2, _step2, p, _nodes, ids, _iterator3, _step3, _p;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this = this;
              if (!(!param || param.constructor === Array && !param.length || param.constructor === Object && !Object.keys(param).length)) {
                _context11.next = 3;
                break;
              }
              throw new Error('Input parameter is invalid.');
            case 3:
              _context11.prev = 3;
              if (!(param.constructor === String || param.constructor === Number)) {
                _context11.next = 9;
                break;
              }
              _context11.next = 7;
              return this.removeNode(param);
            case 7:
              _context11.next = 50;
              break;
            case 9:
              if (!(param.constructor === Array)) {
                _context11.next = 29;
                break;
              }
              // if passing in id array
              _iterator2 = _createForOfIteratorHelper(param);
              _context11.prev = 11;
              _iterator2.s();
            case 13:
              if ((_step2 = _iterator2.n()).done) {
                _context11.next = 19;
                break;
              }
              p = _step2.value;
              _context11.next = 17;
              return this.removeNode(p);
            case 17:
              _context11.next = 13;
              break;
            case 19:
              _context11.next = 24;
              break;
            case 21:
              _context11.prev = 21;
              _context11.t0 = _context11["catch"](11);
              _iterator2.e(_context11.t0);
            case 24:
              _context11.prev = 24;
              _iterator2.f();
              return _context11.finish(24);
            case 27:
              _context11.next = 50;
              break;
            case 29:
              _context11.next = 31;
              return this.findNodes(param);
            case 31:
              _nodes = _context11.sent;
              ids = _nodes.map(function (node) {
                return node[_this.id];
              });
              _iterator3 = _createForOfIteratorHelper(ids);
              _context11.prev = 34;
              _iterator3.s();
            case 36:
              if ((_step3 = _iterator3.n()).done) {
                _context11.next = 42;
                break;
              }
              _p = _step3.value;
              _context11.next = 40;
              return this.removeNode(_p);
            case 40:
              _context11.next = 36;
              break;
            case 42:
              _context11.next = 47;
              break;
            case 44:
              _context11.prev = 44;
              _context11.t1 = _context11["catch"](34);
              _iterator3.e(_context11.t1);
            case 47:
              _context11.prev = 47;
              _iterator3.f();
              return _context11.finish(47);
            case 50:
              _context11.next = 55;
              break;
            case 52:
              _context11.prev = 52;
              _context11.t2 = _context11["catch"](3);
              throw new Error('Failed to remove nodes.');
            case 55:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[3, 52], [11, 21, 24, 27], [34, 44, 47, 50]]);
      }));
      function removeNodes(_x16) {
        return _removeNodes.apply(this, arguments);
      }
      return removeNodes;
    }()
  }]);
  return JSONDigger;
}();
;
module.exports = JSONDigger;